import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

export default function Header() {
	const location = useLocation();

	return (
		<section className="hero-section">
			<div className="hero-overlay" />
			<div className="hero-content">
				{location.pathname === "/home" ? (
					<div className="hero-actions">
						<Link to="/login" className="login-button-home">
							ورود اعضای هیئت علمی
						</Link>
					</div>
				) : (
					<></>
				)}

				<div className="hero-text">
					<h1 className="hero-title">
						{" "}
						فهرست اعضای هیات علمی دانشگاه صنعتی خواجه‌نصیر‌الدین
						طوسی
					</h1>
					<p className="hero-description">
						با اعضای برجسته هیئت علمی ما که رهبران حوزه‌های تحقیقاتی
						و آموزشی خود هستند، آشنا شوید.
					</p>
				</div>

				<div className="hero-logo">
					<div className="logo-background">
						<img
							src="/kntu-logo.png"
							alt="university logo"
							className="logo-image"
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
